<template>
    <div id="app">
        <div class="background-hands"/>
        <div :class="sectionClass" id="content">
            <router-view role="application"></router-view>
            <keep-alive>
                <component :is="gameClientComponent"/>
            </keep-alive>
            <keep-alive>
                <api-client></api-client>
            </keep-alive>
        </div>
        <debug-panel v-if="showDebugPanel"></debug-panel>
        <version-info></version-info>
        <transition name="fade">
            <error-container :errorIcon="errorIcon" v-if="errorMessage" v-on:click.native="onErrorDismiss">
                {{ errorMessage }}
            </error-container>
        </transition>

        <cookie-law theme="dark-lime">
            <div slot-scope="props" class="d-flex w-100">
                <p class="p-2 flex-grow-1">
                    Os Online bruger cookies til at forbedre oplevelsen af spillet og føre statistik.
                </p>
                <div class="p-2">
                    <app-button v-on:onClick="props.accept" class="float-right">OK</app-button>
                </div>
            </div>
        </cookie-law>
    </div>
</template>

<script>
    import GameClientOnline from '@/components/app-components/game-client'
    import GameClientOffline from '@/components/app-components/game-client-offline'

    import ApiClient from '@/components/app-components/api-client'
    import DebugPanel from '@/components/debug/debug-panel'
    import VersionInfo from '@/components/version-info'
    import {$eBus} from '@/event-bus/index'
    import GameClientEvent from '@/enum/GameClientEvent'
    import GameClientType from '@/enum/GameClientType'
    import ErrorContainer from '@/components/error-container'
    import AppConfig from '@/app-config'

    import * as MutationTypes from '@/store/mutation-types'
    import {mapGetters} from 'vuex'
    import CookieLaw from 'vue-cookie-law'
    import AppButton from "./components/app-button/index";

    export default {
        name: 'app',
        components: {
            AppButton,
            'game-client-online': GameClientOnline,
            'game-client-offline': GameClientOffline,
            DebugPanel,
            ApiClient,
            ErrorContainer,
            VersionInfo,
            CookieLaw,
        },
        data() {
            return {
                currentPageName: null
            }
        },
        mounted() {
            $eBus.$on(GameClientEvent.Close, this.onGameClientClose)

            this.currentPageName = this.$router.currentRoute.name
        },
        beforeDestroy() {
            $eBus.$off(GameClientEvent.Close, this.onGameClientClose)
        },
        methods: {
            onGameClientClose() {
                let redirectUrl = this.gameClientCloseRedirectUrl || '/'

                console.log('Game client connection was closed - redirecting to ' + redirectUrl)

                // Make sure we disable navigation guard because something obviously went wrong
                this.$store.commit(MutationTypes.SET_NAVIGATION_GUARD_ENABLED, false)

                // If the game client connection closes, let's go back to the index page
                this.$router.push(redirectUrl)
            },
            onErrorDismiss() {
                if (this.errorCallback) {
                    this.errorCallback();
                }

                this.$nextTick(() => {
                    this.$store.commit(MutationTypes.CLEAR_ERROR_MESSAGE)
                });
            }
        },
        watch: {
            '$route'(to, from) {
                this.currentPageName = to.name
            }
        },
        computed: {
            ...mapGetters({
                gameClientType: 'getGameClientType',
                gameClientCloseRedirectUrl: 'getGameClientCloseRedirectUrl',
                errorMessage: 'getErrorMessage',
                errorIconType: 'getErrorIcon',
                errorCallback: 'getErrorCallback',
            }),
            gameClientComponent() {
                if (this.gameClientType === GameClientType.Online) {
                    return 'game-client-online'
                } else if (this.gameClientType === GameClientType.Offline) {
                    return 'game-client-offline'
                } else if (this.gameClientType) {
                    console.error(`Unknown game client type "${this.gameClientType}"`);
                }

                return null
            },
            errorIcon() {
                if (this.errorIconType === 'connectionError') {
                    return 'misc/connection-error.png'
                }

                return 'misc/error.png'
            },
            showDebugPanel() {
                return AppConfig.showDebugPanel
            },
            sectionClass() {
                let pageName = this.currentPageName

                if (pageName === 'StudentPage') {
                    return 'section-student'
                } else if (pageName === 'TeacherPage') {
                    return 'section-teacher'
                } else if (pageName === 'SinglePlayerPage') {
                    return 'section-single-player'
                }

                return 'section-other'
            }
        }
    }
</script>

<style lang="less">
    @import "~@less/main.less";

    #content {
        &.section-teacher {
            //.backgroundCover("~@img/backgrounds/teacher-background.jpg");
        }

        &.section-student {
            //.backgroundCover("~@img/backgrounds/student-background.jpg");

            height: 100%;
        }

        &.section-single-player {
            //.backgroundCover("~@img/backgrounds/student-background.jpg");

            height: 100%;
        }
    }

    .single-player-page {
        .page-component-container {
            p.description {
                font-size: @font-size-sm;
                text-align: center;
            }

            .page-component-text {
                p.description {
                    text-align: left !important;
                }
            }

            .breadcrumb-container {
                width: 100%;
                text-align: center;
            }

            .breadcrumb-link {
                font-family: @font-family-titillium !important;
                text-align: left;
                width: 100%;
                display: block;
            }
        }
    }

    .background-hands {
        background: url("~@img/misc/hands.png");
        width: 350px;
        height: 160px;
        position: fixed;
        bottom: 0;
        left: 50%;
        margin-left: -(350px / 2);
        z-index: -1;
    }

    .media-max-xs({
        .fade-enter,
        .fade-enter-to,
        .fade-enter-active,
        .fade-leave,
        .fade-leave-to,
        .fade-leave-active {
            transition-duration: 0ms !important;
            transition: none !important;

            animation-duration: 0ms !important;
            animation: none !important;
        }
    });
</style>
